import React from 'react';
import { StyleSheet, View, type ViewProps } from 'react-native';
import { useStyle } from 'react-native-style-utilities';

import { theme } from '@garnish/constants';
import { useContainerSpacing, useResponsive } from '@garnish/core';

export const FlexLandingPageContent = (props: ViewProps) => {
  const { match } = useResponsive();
  const paddingHorizontal = useContainerSpacing();
  const spacingSM = useStyle(() => ({ paddingHorizontal }), [paddingHorizontal]);
  const spacingStyle = match([styles.spacingXS, [spacingSM, styles.containerSM]]);

  return <View style={[spacingStyle, props.style]}>{props.children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerSM: {
    maxWidth: 1520,
    alignSelf: 'center',
  },
  spacingXS: {
    paddingHorizontal: theme.spacing['4'],
  },
});
